module.exports = __webpack_public_path__ + "img/11.edc96ae2.jpg";